import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { db } from "@/lib/firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const MAX_REFERRER_LEN = 8192;
const BLOCKED_CURRENT_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

function normalizeHost(host) {
  if (!host) return "";
  return host
    .toLowerCase()
    .replace(/^www\./, "")
    .replace(/:\d+$/, "");
}

function safeParseUrl(url) {
  try {
    return new URL(url);
  } catch {
    return null;
  }
}

function sanitizeForLog(s) {
  if (!s) return "";
  let out = "";
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    if (c <= 0x1f || c === 0x7f) continue;
    out += s[i];
  }
  return out;
}

function getQueryReferrerAndRemoveParam() {
  const url = new URL(window.location.href);
  const raw = url.searchParams.get("referrer") || "";

  // ✅ referrer 파라미터는 무조건 제거 (성공/실패 상관 없이)
  if (url.searchParams.has("referrer")) {
    url.searchParams.delete("referrer");
    window.history.replaceState({}, "", url.toString());
  }

  if (!raw) return { referrer: "", truncated: false };

  let decoded = raw;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return;
  }

  decoded = sanitizeForLog(decoded);

  // http/https만 허용
  if (!/^https?:\/\//i.test(decoded)) return { referrer: "", truncated: false };

  const parsed = safeParseUrl(decoded);
  if (!parsed) return { referrer: "", truncated: false };

  const full = sanitizeForLog(parsed.toString());
  const truncated = full.length > MAX_REFERRER_LEN;
  const finalRef = truncated ? full.slice(0, MAX_REFERRER_LEN) : full;

  return { referrer: finalRef, truncated };
}

async function logExternalReferrer() {
  const currentHost = normalizeHost(window.location.hostname);

  // ✅ localhost에서는 저장 금지 (하지만 referrer 파라미터는 제거)
  if (BLOCKED_CURRENT_HOSTS.has(currentHost)) {
    getQueryReferrerAndRemoveParam();
    return;
  }

  const { referrer, truncated } = getQueryReferrerAndRemoveParam();
  if (!referrer) return;

  const refUrl = safeParseUrl(referrer);
  const referrerHost = normalizeHost(refUrl?.host || "");

  const payload = {
    createdAt: serverTimestamp(),
    referrer,
    referrerHost,
    referrerTruncated: truncated,
    currentUrl: window.location.href, // referrer 제거된 URL
    currentHost,
    userAgent: navigator.userAgent,
  };

  try {
    await addDoc(collection(db, "trafficLogs"), payload);
  } catch (e) {
    console.warn("external referrer log failed:", e);
  }
}

logExternalReferrer();

createApp(App).use(router).mount("#app");
